<template>
    <div class="im-image-list">
        <template v-if="!single">
            <div class="image-unit" :style="sizeStyle" v-for="(image, index) in imageList"
                :key="index">
                <div class="image-wrap">
                    <img :src="image">
                </div>
                <div class="action-cover flex-center">
                    <Icon v-if="!readonly && !disabled" type="ios-trash-outline" @click="handleRemove(index)"></Icon>
                    <Icon type="ios-eye-outline" @click="handlePreview(index)"></Icon>
                    <Icon v-if="!readonly && !disabled" type="ios-arrow-back" @click="handleMoveLeft(index)"></Icon>
                    <Icon v-if="!readonly && !disabled" type="ios-arrow-forward" @click="handleMoveRight(index)"></Icon>
                </div>
            </div>
        </template>
        <div v-if="single && image" class="image-unit" :style="sizeStyle" style="margin-right: 0;">
            <div class="image-wrap">
                <img :src="image">
            </div>
            <div class="action-cover flex-center">
                <Icon type="ios-eye-outline" @click="handlePreview()"></Icon>
                <Icon v-if="!readonly && !disabled" type="ios-trash-outline" @click="handleRemove"></Icon>
            </div>
        </div>
        <div v-if="uploading" class="image-unit" :style="sizeStyle">
            <div class="uploading-text flex-center">上传中...</div>
        </div>
        <Upload v-if="!this.disabled && !this.readonly && showUploader" class="uploader"
            :style="sizeStyle" name="image" :action="action" :show-upload-list="false"
            :format="['jpg','jpeg','png']" accept=".jpg, .jpeg, .png"
            :before-upload="handleBeforeUpload" :on-format-error="handleFormatError"
            :on-success="handleUploadSuccess" :on-error="handleUploadError">
            <div class="flex-center">
                <Icon type="md-camera" :size="32"></Icon>
            </div>
        </Upload>
        <!-- <div v-if="(disabled || readonly) && showUploader" class="uploader ivu-upload"
            :class="{'uploader-disabled': disabled}" :style="sizeStyle">
            <div class="ivu-upload ivu-upload-select">
                <div class="flex-center">
                    <Icon type="md-camera" :size="32"></Icon>
                </div>
            </div>
        </div> -->
    </div>
</template>
<script>
import constants from "../utils/constants";
import util from "../utils/util";

export default {
    data() {
        return {
            uploading: false,
            action: util.wrapApi(constants.apiHost + "/utils/upload/img"),
        };
    },
    props: {
        single: {
            type: Boolean,
            default: false,
        },
        value: {
            default: "",
        },
        max: {
            type: Number,
            default: 0,
        },
        extra: {
            type: Object,
            default: () => {},
        },
        width: {
            type: Number,
            default: 1.2,
        },
        height: {
            type: Number,
            default: 0.8,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        imageList() {
            return this.value || [];
        },
        image() {
            return this.value;
        },
        showUploader() {
            return (
                (!this.single &&
                    (this.imageList.length < this.max || this.max === 0)) ||
                (this.single && !this.image && !this.uploading)
            );
        },
        sizeStyle() {
            return {
                width: this.width + "rem",
                height: this.height + "rem",
            };
        },
    },
    mounted() {
        // let self = this;
    },
    methods: {
        handleMoveLeft(index) {
            let self = this;

            if (0 === index) {
                return;
            } else {
                let list = JSON.parse(JSON.stringify(self.imageList));
                let tmp = list[index - 1];
                list[index - 1] = list[index];
                list[index] = tmp;
                self.$emit("input", list);
            }
        },
        handleMoveRight(index) {
            let self = this;

            if (self.imageList.length - 1 === index) {
                return;
            } else {
                let list = JSON.parse(JSON.stringify(self.imageList));
                let tmp = list[index + 1];
                list[index + 1] = list[index];
                list[index] = tmp;
                self.$emit("input", list);
            }
        },
        handleRemove(index) {
            let self = this;
            if (self.single) {
                self.$emit("input", "");
            } else {
                self.imageList.splice(index, 1);
                self.$emit("input", self.imageList);
            }
        },
        handlePreview(index = -1) {
            let self = this;
            if (index == -1) {
                self.$MediaPreview([self.image], 0);
            } else {
                self.$MediaPreview(self.imageList, index);
            }
        },
        handleBeforeUpload(file) {
            let self = this;
            if (!self.uploading) {
                self.uploading = true;
            } else {
                return false;
            }
        },
        handleUploadSuccess(response, file, fileList) {
            console.log("111111 ~ file: ImageManager.vue ~ line 142 ~ handleUploadSuccess ~ response", response);
            let self = this;
            self.uploading = false;

            if (response.status.code != 1001) {
                 self.$Message.error(
                    response.status.msg ? response.status.msg : "服务异常，请稍候再试。"
                );
                return;
            }

            let data = response.result;

            if (self.single) {
                self.$emit("input", data.url);
                self.$emit("success", { extra: self.extra, image: data.url });
            } else {
                if (self.imageList.length >= self.max && self.max != 0) {
                    return;
                }
                self.imageList.push(data.url);
                self.$emit("input", self.imageList);
                self.$emit("success", {
                    extra: self.extra,
                    image: self.imageList,
                });
            }
        },
        handleUploadError() {
            let self = this;
            self.uploading = false;
            self.$Message.error("上传失败");
        },
        handleFormatError(file) {
            let self = this;
            // console.log(file);
            self.uploading = false;
            self.$Message.warning("选择的文件类型不正确");
        },
    },
};
</script>

<style lang="less">
.im-image-list {
    .image-unit {
        display: inline-block;
        text-align: center;
        border: 0.01rem solid transparent;
        border-radius: 0.04rem;
        overflow: hidden;
        background: #fff;
        position: relative;
        box-shadow: 0 0.01rem 0.01rem rgba(0, 0, 0, 0.2);
        margin-right: 0.1rem;
        .image-wrap {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 100%;
            img {
                max-width: 100%;
                max-height: 100%;
            }
        }
        .action-cover {
            display: none;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            background: rgba(0, 0, 0, 0.6);
            i {
                color: #fff;
                font-size: 0.2rem;
                cursor: pointer;
                margin: 0 0.02rem;
            }
        }
        .uploading-text {
            height: 100%;
            width: 100%;
        }
        &:hover {
            .action-cover {
                display: flex;
            }
        }
    }
    .uploader {
        display: inline-block;
        text-align: center;
        border: 0.01rem solid transparent;
        border-radius: 0.04rem;
        overflow: hidden;
        background: #fff;
        position: relative;
        box-shadow: 0 0.01rem 0.01rem rgba(0, 0, 0, 0.2);
        cursor: pointer;
        &.uploader-disabled {
            background-color: #f3f3f3;
        }
        div {
            height: 100%;
            width: 100%;
        }
    }
}
</style>
